import { render, staticRenderFns } from "./VSkeletonPDF.vue?vue&type=template&id=081bd9d2"
import script from "./VSkeletonPDF.vue?vue&type=script&lang=js"
export * from "./VSkeletonPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081bd9d2')) {
      api.createRecord('081bd9d2', component.options)
    } else {
      api.reload('081bd9d2', component.options)
    }
    module.hot.accept("./VSkeletonPDF.vue?vue&type=template&id=081bd9d2", function () {
      api.rerender('081bd9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/skeletonLoader/VSkeletonPDF.vue"
export default component.exports